export const DISCONNECTED = "Disconnected";
export const ACTUAL_OVER_BASELINE = "OverBaseline";
export const LIGHTS_OVER_THRESHOLD = "LightsOverThreshold";
export const HVAC_OVER_THRESHOLD = "HvacOverThreshold";
